import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

  transform(list: any[], filter=[]): any {
    if (!list) return false;
    let keys = Object.keys(filter);
    return list.filter( o =>{
      let valid = true;
      filter.map( oF =>{
        let key = Object.keys(oF)[0];
        if( typeof(oF[key]) == "object"){
          valid = valid && eval(`${o[key]} ${oF[key][0]} ${oF[key][1]}`);
        }else{
          valid = valid && o[key] == oF[key];
        }
      });
      return valid;
    });
  }

}
